<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品分组
      <small>
        /&nbsp;
        <router-link to="/packmanagement" class="TitleStyle">分组报价</router-link>/&nbsp;设置报价
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">设置报价</h4>
              </div>
              <div class="panel-body">
                <form
                  
                  style="margin-top:16px;padding-left:15px;"
                >
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <div class="col-md-8">
                        <!-- <ul style="list-style:none;background:#929ba1;">
                          <li class="PriceLi">分组名:</li>
                          <li class="PriceLi"></li>
                          <li class="PriceLi">商品名称:</li>
                          <li class="PriceLi"></li>
                          <li class="PriceLi">包装率:</li>
                          <li class="PriceLi"></li>
                          <li class="clear"></li>
                        </ul> -->
                      </div>
                      <div class="col-md-3"></div>
                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor"
                          @click="AddClick()"
                          style="float:right;"
                        >新增</a>
                      </div>
                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>
                <!-- end panel-heading -->
                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
                  <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
                  <el-table-column prop="quotedPrice" label="报价" align="center"></el-table-column>
                  <el-table-column prop="advicePrice" label="建议售价" align="center"></el-table-column>
                  <el-table-column prop="isfree" label="是否包邮" align="center"></el-table-column>
                  <el-table-column prop="expressFee" label="运费" align="center"></el-table-column>
        
                  <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                      <a
                        class="btn btn-warning btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="DeleteClick(scope.row)"
                      >删除</a>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
                <div class="clear"></div>
                <!-- end panel -->

                <div style="height:46px;padding-top:16px;">
                  <a class="btn btn-primary m-r-5 BackButton" @click="GoBack">返&nbsp;&nbsp;回</a>

                  <span class="clear"></span>
                </div>
              </div>
            </div>
          </div>
          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure"  :disabled = 'disabled'>确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">新增</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
     
          <el-form-item label="开始时间:" prop="startTime" >
            <el-date-picker v-model="ruleForm.startTime" type="date" placeholder="选择日期" style="width:calc(100% - 16px);margin-left:16px" ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" prop="endTime"  >
            <el-date-picker v-model="ruleForm.endTime" type="date" placeholder="选择日期" style="width:calc(100% - 16px);margin-left:16px" ></el-date-picker>
          </el-form-item>

          <el-form-item label="报价:" prop="quotedPrice">
            <el-input v-model="ruleForm.quotedPrice"  class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="建议售价:" prop="salesPrice">
            <el-input v-model="ruleForm.salesPrice"  class="DistributorMargin"></el-input>
          </el-form-item>
       
          <el-form-item label="是否包邮:" prop="isFee">
            <el-select v-model="ruleForm.isFee" clearable placeholder="请选择"  style="width:100%"  class="DistributorMargin" @change="isFeeChange">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="运费:" prop="expressFee" v-if="expressFreeShow">
            <el-input v-model="ruleForm.expressFee"  class="DistributorMargin"></el-input>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled = 'disabled'
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "PackPrice",
  data() {
   var checkquotedPrice = (rule, value, callback) => {
  
      setTimeout(() => {
        let reg=/^\d+(\.\d{1,2})?$/;
        if (!reg.test(value)) {
          callback(new Error("大于0且不能超过两位小数"));
        } else {
          callback();
        }
      }, 1000);
    };
   var checkTime = (rule, value, callback) => {
  
      setTimeout(() => {

        if (value< this.ruleForm.startTime) {
          callback(new Error("结束时间必须晚于开始时间"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkTimes = (rule, value, callback) => {
  
      setTimeout(() => {

        if (value> this.ruleForm.endTime) {
          callback(new Error("开始时间必须早于结束时间"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      value1:'',
      outerVisible: false,
      EditDialog: 1,
      options: [
        {
          label: "是",
          value: 0
        },
        {
          label: "否",
          value: 1
        }
      ],
      UserManagementList:[],
      value4: "",
      pageindex:1,
      ruleForm: {
      
      },
      rules: {
         startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
          { validator: checkTimes, trigger: "blur" }
        
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
          { validator: checkTime, trigger: "blur" }
        ],
        quotedPrice: [
          { required: true, message: "请输入报价", trigger: "blur" },
          { validator: checkquotedPrice, trigger: "blur" }
        ],
        salesPrice: [
          { required: true, message: "请输入建议报价", trigger: "blur" },
           { validator: checkquotedPrice, trigger: "blur" }
        ],
        isFee: [
          { required: true, message: "请选择是否包邮", trigger: "blur" }
        ],
      },
      row:[],
      pageSize: 10,
      totalCount: 0,
      disabled: false,
      expressFreeShow: false,
      searchContent:{}
    };
  },
  mounted: function() {
    this.initdata();
  },
  methods: {
    initdata() {
     let that = this;
     if(localStorage.getItem('goodlists')){
       let goodlists =localStorage.getItem('goodlists');
       this.row = JSON.parse(goodlists).row;
       this.pageNo = JSON.parse(goodlists).pageNo;
       this.pageSize = JSON.parse(goodlists).pageSize;
       this.searchContent = JSON.parse(goodlists).searchContent;
        const options = {
        url: "distribution/B2cGoodsPackageRates/queryQuotedPrice",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          groupId: that.row.groupId,
          goodsId: that.row.goodsId,
          packagerates: that.row.packageRates
        })
      };
      axios(options)
        .then(function(response) {

          if (response.data.code == 200) {

      
            that.UserManagementList = response.data.data.records;
            that.totalCount = response.data.data.total;
             response.data.data.records.forEach(element => {
               if(element.isFee === 0){
                 element.isfree = '包邮';
               }else if(element.isFee === 1){
                 element.isfree = '不包邮';
               }
             });
          } else {
           http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
      }


    },
    isFeeChange(val){
  
      if(val === 0){
        this.expressFreeShow = false;
    
      }else if(val === 1){
       this.expressFreeShow = true;
    
       
      }
    
    },
    MakeSure(){
      let that = this;
       that.disabled = true;
        const options = {
              url: "distribution/B2cGoodsPackageRates/deleteQuotedPrice",
              method: "post",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              },
                 data: Qs.stringify({
          groupId: that.row.groupId,
          goodsId: that.row.goodsId,
          packagerates: that.row.packagerates
        })
            };
            axios(options)
              .then(function(response) {
                 that.disabled = false;
                 that.outerVisible = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                   http.handleEorrorCode(response,that);
                }
              })
              .catch(function(error) {
            
                 that.disabled = false;
                   that.outerVisible = false;
                http.handleHttpError(error, that);
              });
    },
     handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    DeleteClick() {
      this.outerVisible = true;
      this.EditDialog = 2;
    },
    AddClick() {
      this.outerVisible = true;
      this.EditDialog = 1;
      this.ruleForm = {};
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
    MakeSureEdit(formName) {
      let that = this;
       that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            if(that.ruleForm.isFee === 0){
              that.ruleForm.expressFee =  0
            }
            const options = {
              url: "distribution/B2cGoodsPackageRates/setQuotedPrice",
              method: "post",
              headers: {
                "Content-Type": "application/json"
              },
              data:{
                 groupId: that.row.groupId,
                goodsId: that.row.goodsId,
                packagerates: that.row.packagerates,
                data:[{
                    startTime: that.FormatSpecialDate(that.ruleForm.startTime),
                    endTime: that.FormatSpecialDate(that.ruleForm.endTime),
                    quotedPrice: that.ruleForm.quotedPrice,
                    salesPrice: that.ruleForm.salesPrice,
                    isFee: that.ruleForm.isFee.toString(),
                    expressFee: that.ruleForm.expressFee.toString(),
                    
                }]
              
              }
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                 that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: "新增成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response,that);
                }
              })
              .catch(function(error) {
                  that.outerVisible = false;
                 that.disabled = false;
                http.handleHttpError(error, that);
              });
          }
       })
    },
    GoBack() {
      this.$router.push({ name: "PackManagement" , 
        params: { pageNo : this.pageNo,pagesize:this.pageSize,groupId:this.row.groupId,searchContent:this.searchContent},
        query: { groupId: this.groupId}});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 105px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.BackButton {
  float: right;
  cursor: pointer;
  color: #fff !important;
}
.PriceLi {
  float: left;
  width: 100px;
  height: 32px;
  line-height: 32px;
  color: #fff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupManage/PackPrice.vue